// Shared topics taxonomy for SEO landing pages and filters.
// `en` is the canonical value stored in DB (news.category). `fr` is display only.

export const TOPICS = [
  {
    slug: "ai-in-supply-chain",
    en: "AI in Supply Chain",
    fr: "IA Supply Chain",
    descEn: "AI news, jobs and signals for the entire Supply Chain function — planning, execution and governance.",
    descFr: "Actualités IA, recrutements et signaux pour toute la fonction Supply Chain — planification, exécution et gouvernance.",
  },
  {
    slug: "planning",
    en: "Planning",
    fr: "Planification",
    descEn: "Demand forecasting, supply planning, agentic AI in planning. The most active battlefield of Supply Chain AI.",
    descFr: "Prévision de la demande, planification de la supply, agents IA en planification. Le terrain le plus actif de l'IA en Operations.",
  },
  {
    slug: "inventory",
    en: "Inventory",
    fr: "Stocks",
    descEn: "AI-driven inventory optimization, multi-echelon, safety stock and slow-mover signals.",
    descFr: "Optimisation des stocks par IA, multi-échelon, stock de sécurité et signaux sur les références à faible rotation.",
  },
  {
    slug: "sop-ibp",
    en: "S&OP / IBP",
    fr: "S&OP / IBP",
    descEn: "How AI reshapes the S&OP and Integrated Business Planning rituals, scenarios and governance.",
    descFr: "Comment l'IA transforme les rituels, scénarios et la gouvernance du S&OP et de l'IBP.",
  },
  {
    slug: "sourcing-procurement",
    en: "Sourcing / Procurement",
    fr: "Achats / Sourcing",
    descEn: "AI in sourcing, supplier risk, category management and procurement orchestration.",
    descFr: "IA dans le sourcing, le risque fournisseurs, le category management et l'orchestration des achats.",
  },
  {
    slug: "manufacturing",
    en: "Manufacturing",
    fr: "Production",
    descEn: "AI on the shop floor — scheduling, quality, OEE and connected workforce.",
    descFr: "L'IA sur le terrain industriel — ordonnancement, qualité, TRS et opérateurs connectés.",
  },
  {
    slug: "warehousing-logistics",
    en: "Warehousing / Logistics",
    fr: "Entrepôts / Logistique",
    descEn: "AI in warehousing, transportation, last-mile and global logistics orchestration.",
    descFr: "IA en entrepôts, transport, livraison du dernier kilomètre et orchestration logistique globale.",
  },
  {
    slug: "it-ai-governance",
    en: "IT & AI Governance",
    fr: "Gouvernance IT & IA",
    descEn: "Operating models, governance, security and trust for AI decision systems in Operations.",
    descFr: "Modèles opérationnels, gouvernance, sécurité et confiance pour les systèmes de décision IA en Opérations.",
  },
];

export const topicBySlug = (slug) => TOPICS.find((t) => t.slug === slug);

export const slugOfTopic = (en) => {
  const t = TOPICS.find((x) => x.en === en);
  return t ? t.slug : null;
};
